import { Languages } from '../../interfaces/common'
import { IIsCaptchaNeededData } from '../../interfaces/IIsCaptchaNeededData'
import { apiGet } from '../api'
import { IS_CAPTCHA_NEEDED } from '../URLs'
import { useMutationHook } from './mutationHook'

export async function mutationFn(path: string, params: object, locale: Languages): Promise<IIsCaptchaNeededData> {
  const { data } = await apiGet<object, IIsCaptchaNeededData>({ path, params, locale })

  return data
}

export function useIsCaptchaNeeded() {
  const path = IS_CAPTCHA_NEEDED
  const mutationFunc = useMutationHook({ path, mutationFn })

  return async () => mutationFunc({})
}
